<template>
    <img class="defaultImg" :src="imageSrc" :object-fit="mode" @error="error" @load="load" alt="">
</template>

<script>
    export default {
        name: "defaultImg",
        props:{
            errorSrc: {
                type: String,
                default: require('@/assets/images/default.jpeg')
            },
            src: {
                type: String,
                default: ''
            },
            mode: {
                type: String,
                default: 'fill'
            }
        },
        data(){
            return{
                imageSrc:''
            }
        },
        methods:{
            error(e) {
                // console.log('加载失败',e)
                this.imageSrc = this.errorSrc;
            },
            load(e) {
                // console.log('加载中',e)
            },
        },
        watch:{
            src:{
                handler(newSrc,oldSrc){
                    this.imageSrc = newSrc?newSrc:'http://wrong address';
                },
                immediate: true
            }
        }
    }
</script>

<style lang="less" scoped>
    .defaultImg{
        display: block;
    }
</style>
